/* import __COLOCATED_TEMPLATE__ from './staff-packages-fe-mount.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import 'systemjs';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import * as Sentry from '@sentry/browser';
import { mountRootParcel } from 'single-spa';
import { or } from '@ember/object/computed';
import * as singleSpa from 'single-spa';
import { inject as service } from '@ember/service';
export const API_PATH = '/staffpackages-fe/api/dashboard-spa-manifest';
let StaffPackagesFeMount = (_dec = or('mountFailure', 'apiEndpointFailuire'), (_class = class StaffPackagesFeMount extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "parcel", void 0);
    _defineProperty(this, "module", void 0);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
    _initializerDefineProperty(this, "applicationRouter", _descriptor2, this);
    _initializerDefineProperty(this, "employeeInfo", _descriptor3, this);
    _initializerDefineProperty(this, "employeeSubscription", _descriptor4, this);
    _initializerDefineProperty(this, "eventstream", _descriptor5, this);
    _initializerDefineProperty(this, "modal", _descriptor6, this);
    _initializerDefineProperty(this, "userSubscriptions", _descriptor7, this);
    _initializerDefineProperty(this, "features", _descriptor8, this);
    _initializerDefineProperty(this, "userRailsPermissions", _descriptor9, this);
    _initializerDefineProperty(this, "environment", _descriptor10, this);
    _initializerDefineProperty(this, "mountFailure", _descriptor11, this);
    _initializerDefineProperty(this, "apiEndpointFailure", _descriptor12, this);
    _initializerDefineProperty(this, "bundle", _descriptor13, this);
    _initializerDefineProperty(this, "baseUrl", _descriptor14, this);
    _initializerDefineProperty(this, "mountOrApiFailure", _descriptor15, this);
  }
  async setupApp(domElement) {
    const {
      mfeBundleUrl
    } = await this.load();
    if (mfeBundleUrl) {
      try {
        singleSpa.start();
        this.module = await System.import(mfeBundleUrl);
        if (this.module) {
          await this.mountApplication(this.module, domElement);
        }
      } catch (error) {
        this.mountFailure = true;
        Sentry.captureException(error);
      }
    } else {
      this.apiEndpointFailure = true;
    }
  }
  async mountApplication(module, domElement) {
    const parcelConfig = {
      bootstrap: module.bootstrap,
      mount: module.mount,
      unmount: module.unmount
    };
    const parcelProps = {
      domElement,
      ...this.customProps
    };
    this.parcel = mountRootParcel(parcelConfig, parcelProps);
    await this.parcel.mountPromise;
  }
  teardownApp() {
    if (this.parcel) {
      this.parcel.unmount().catch(e => Sentry.captureException(e));
    }
  }
  get customProps() {
    return {
      ...this.args.customProps,
      applicationRouter: this.applicationRouter,
      baseUrl: this.baseUrl,
      employeeInfoService: this.employeeInfo,
      employeeSubscriptionService: this.employeeSubscription,
      eventstreamService: this.eventstream,
      featuresService: this.features,
      modalService: this.modal,
      userInfoService: this.userInfo,
      userSubscriptionsService: this.userSubscriptions,
      userRailsPermissionsService: this.userRailsPermissions
    };
  }
  async load() {
    let responseJson;
    try {
      const response = await fetch(this.endpoint);
      if (response.ok) {
        responseJson = await response.json();
      } else {
        throw new Error(`Bad response code ${response.status} from staffpackages-fe API endpoint`);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
    return {
      mfeBundleUrl: responseJson ? `${responseJson.app.cdnOrigin}/${responseJson.app[this.args.bundle]}` : null
    };
  }

  // Use Requestly to redirect traffic from staging or production to locally served bundle
  get endpoint() {
    const {
      isProduction,
      isSandbox,
      isTesting
    } = this.environment;
    if (isTesting) {
      return API_PATH;
    } else if (isProduction || isSandbox) {
      return `https://app.squareup.com${API_PATH}`;
    } else {
      // Regular development, and staging all use staging
      return `https://app.squareupstaging.com${API_PATH}`;
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "applicationRouter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "employeeInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "employeeSubscription", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "eventstream", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "modal", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "userSubscriptions", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "userRailsPermissions", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "environment", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "mountFailure", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "apiEndpointFailure", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "bundle", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.bundle;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "baseUrl", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.baseUrl;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "mountOrApiFailure", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setupApp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setupApp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "teardownApp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "teardownApp"), _class.prototype)), _class));
export { StaffPackagesFeMount as default };